import { createContext, type ReactNode } from 'react';

/**
 * 서버에서 받아온 국가 코드를 관리하는 Context
 *
 * @description
 * - getServerSideProps에서 받아온 국가 코드를 이 Provider에 주입하여 사용하세요.
 *
 **/

interface CountryCodeFromServerContextValue {
  countryCode: string;
}
export const CountryCodeFromServerContext = createContext<CountryCodeFromServerContextValue | undefined>(undefined);
export function CountryCodeFromServerProvider({
  children,
  countryCode
}: {
  countryCode: string;
  children: ReactNode;
}) {
  return <CountryCodeFromServerContext.Provider value={{
    countryCode
  }} data-sentry-element="unknown" data-sentry-component="CountryCodeFromServerProvider" data-sentry-source-file="CountryCodeFromServerProvider.tsx">
      {children}
    </CountryCodeFromServerContext.Provider>;
}